import { defineStore } from 'pinia'

export const useLoginStore = defineStore('login', {
  state: () => ({
    isLoginDialogVisible: false
  }),
  actions: {
    openLoginDialog() {
      this.isLoginDialogVisible = true
    },
    closeLoginDialog() {
      this.isLoginDialogVisible = false
    }
  }
})